// noinspection DuplicatedCode

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
// noinspection ES6PreferShortImport
import { PageNotFoundComponent } from '../standalone/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
  },
  {
    path: 'users',
    loadChildren: () =>
      import('../../shared/users/users.module').then((m) => m.UsersModule),
  },

  {
    path: 'companies',
    loadChildren: () =>
      import('../../shared/companies/companies.module').then(
        (m) => m.CompaniesModule,
      ),
  },
  {
    path: 'rfid-tags',
    loadChildren: () =>
      import('../../shared/rfid-tags/rfid-tags.module').then(
        (m) => m.RfidTagsModule,
      ),
  },
  {
    path: 'categories',
    loadChildren: () =>
      import('../../shared/categories/categories.module').then(
        (m) => m.CategoriesModule,
      ),
  },
  {
    path: 'assets',
    loadChildren: () =>
      import('../../shared/assets/assets.module').then((m) => m.AssetsModule),
  },
  {
    path: 'scans',
    loadChildren: () =>
      import('../../shared/scans/scans.module').then((m) => m.ScansModule),
  },
  {
    path: 'locations',
    loadChildren: () =>
      import('../../shared/locations/locations.module').then(
        (m) => m.LocationsModule,
      ),
  },
  {
    path: 'persons',
    loadChildren: () =>
      import('../../shared/persons/persons.module').then(
        (m) => m.PersonsModule,
      ),
  },
  {
    path: 'projects',
    loadChildren: () =>
      import('../../shared/projects/projects.module').then(
        (m) => m.ProjectsModule,
      ),
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('../../shared/settings/settings.module').then(
        (m) => m.SettingsModule,
      ),
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StaffRoutingModule {}
